import styled from 'styled-components6';

export const VerticalDivider = styled.div`
    border-left: 1px solid var(--rwl-palette-gray-300);
    width: 1px;
    height: 100%;
`;

export const HorizontalDivider = styled.div`
    border-top: 1px solid var(--rwl-palette-gray-300);
    width: 100%;
`;
